import React from 'react';
import classNames from 'classnames';
import styles from '../Form.module.scss';

type Props = {
  children: React.ReactNode;
  alignment?: 'left' | 'right';
  hasSeparator?: boolean;
  className?: string;
};

export const FormButtons = ({
  children,
  className,
  alignment = 'left',
  hasSeparator = false,
  ...props
}: Props) => {
  return (
    <div
      className={classNames(
        styles.FormButtons,
        styles[alignment],
        { [styles.hasSeparator]: hasSeparator },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
